import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "../pages/Home ";
import Aboutus from "../pages/Aboutus";
import Faqs from "../pages/Faqs";
import Privacy from "../pages/Privacy";
import Contact from "../pages/Contact";
// import Careers from "../pages/Careers";
import Charges from "../pages/Charges";
import DeleteAccount from "../pages/DeleteAccount";
import Agents from "../pages/Agents";
import PageNotFound from "../pages/error/PageNotFound";

function routes() {
  const [privacy, setPrivacy] = useState({});
  const [condition, setCondition] = useState({});
  return (
    <Routes>
      <Route exact="true" path="/" element={<Home />} />
      <Route path="/about" element={<Aboutus />} />
      <Route path="/faqs" element={<Faqs />} />
      <Route path="/privacy-policy" element={<Privacy privacy={privacy} />} />
      <Route path="/terms-and-conditions" element={<Privacy />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/agents" element={<Agents />} />
      {/* <Route path="/careers" element={<Careers />} /> */}
      <Route path="/delete-account" element={<DeleteAccount />} />
      <Route path="/charges" element={<Charges />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default routes;
